export default {
    columns: {
        displayName: 'Template Name',
        documentType: 'Document Type',
        draft: 'Draft',
        partner: 'Partner',
        templateFileUrl: 'Template File',
        uploadedFileUrl: 'Uploaded File',
    },
    fields: {
        keyword: 'Keyword',
    },
    progress: 'Processed {{currentProgress}} / {{maxProgress}}',
    resultPanel: {
        clear: 'Clear',
        noResults: 'No Results',
        showingResult: 'Showing {{startCount}}-{{endCount}} of {{totalCount}}',
        title: 'Search Result',
    },
    subtitle: 'Use keywords to search all custom templates.',

    title: 'Search Custom Templates',
};
